import React from 'react';
import { useSelector } from 'react-redux';
import ComunicadoModal from '../../comunicado/ComunicadoModal';


function WelcomeWidget(props) {

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    return (
        <div className="col-lg-12 mb-4 order-0">
            <div className="card">
                <div className="d-flex   row">
                    <div className="col-sm-6">
                        <div className="card-body">
                            <h5 className="card-title text-primary">Bienvenido {logguedUserData.username}! 🎉</h5>
                            <p className="mb-4">
                                A continuación encontrarás algunos enlaces que pueden ser de tu interes.
                            </p>


                            {/* <a href="javascript:;" className="btn btn-sm btn-outline-primary">View Badges</a> */}
                        </div>
                    </div>
                    <div className="col-sm-3 text-sm-left ">
                        <ul className='my-3'>
                            <li>Reporte de pagos</li>
                            <li>Nueva tarea</li>
                        </ul>

                    </div>
                    <div className="col-sm-3 text-center text-sm-left">
                        <div className="card-body pb-0 px-0 px-md-4">
                            <img
                                src="/assets/img/illustrations/man-with-laptop-light.png"
                                height="140"
                                alt="View Badge User"
                                data-app-dark-img="illustrations/man-with-laptop-dark.png"
                                data-app-light-img="illustrations/man-with-laptop-light.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WelcomeWidget;